import React from 'react';
import './PetAnimations.css';

export default function DragonSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#7E57C2';
  const bellyColor = '#FFE082';
  const wingColor = color || '#9575CD';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path
        d="M80 82C90 86 100 88 106 84C108 82 106 78 102 80C96 82 88 82 80 80"
        fill={bodyColor}
        stroke="none"
      />
      {/* Tail spike */}
      <path d="M104 82L110 78L106 86Z" fill={bellyColor} />
      {/* Wings - left */}
      <path
        d="M36 50C24 38 16 28 14 26C12 24 10 28 14 34C18 40 26 50 34 56"
        fill={wingColor}
        opacity="0.8"
      />
      <path d="M14 26L20 36M18 30L26 42M22 34L30 48" stroke={bodyColor} strokeWidth="1" opacity="0.5" />
      {/* Wings - right */}
      <path
        d="M84 50C96 38 104 28 106 26C108 24 110 28 106 34C102 40 94 50 86 56"
        fill={wingColor}
        opacity="0.8"
      />
      <path d="M106 26L100 36M102 30L94 42M98 34L90 48" stroke={bodyColor} strokeWidth="1" opacity="0.5" />
      {/* Body */}
      <ellipse cx="60" cy="74" rx="26" ry="22" fill={bodyColor} />
      {/* Belly scales */}
      <ellipse cx="60" cy="78" rx="14" ry="14" fill={bellyColor} />
      <path d="M50 70H70M48 76H72M50 82H70" stroke={bodyColor} strokeWidth="0.5" opacity="0.3" />
      {/* Legs */}
      <ellipse cx="42" cy="92" rx="8" ry="5" fill={bodyColor} />
      <ellipse cx="78" cy="92" rx="8" ry="5" fill={bodyColor} />
      {/* Claws */}
      <circle cx="36" cy="94" r="2" fill={bellyColor} />
      <circle cx="42" cy="96" r="2" fill={bellyColor} />
      <circle cx="84" cy="94" r="2" fill={bellyColor} />
      <circle cx="78" cy="96" r="2" fill={bellyColor} />
      {/* Head */}
      <ellipse cx="60" cy="42" rx="20" ry="18" fill={bodyColor} />
      {/* Horns */}
      <path d="M44 28L38 14L48 26" fill={bellyColor} />
      <path d="M76 28L82 14L72 26" fill={bellyColor} />
      {/* Head ridges */}
      <path d="M52 26L50 20L54 24" fill={wingColor} />
      <path d="M60 24L60 18L62 24" fill={wingColor} />
      <path d="M68 26L70 20L66 24" fill={wingColor} />
      {/* Snout */}
      <ellipse cx="60" cy="48" rx="10" ry="8" fill={bellyColor} opacity="0.5" />
      {/* Eyes */}
      <ellipse cx="50" cy="38" rx="5" ry="5.5" fill="white" />
      <ellipse cx="70" cy="38" rx="5" ry="5.5" fill="white" />
      <ellipse cx="51" cy="38.5" rx="3" ry="3.5" fill="#FF6F00" />
      <ellipse cx="71" cy="38.5" rx="3" ry="3.5" fill="#FF6F00" />
      <ellipse cx="51" cy="38.5" rx="1.5" ry="3" fill="#2C2419" />
      <ellipse cx="71" cy="38.5" rx="1.5" ry="3" fill="#2C2419" />
      <circle cx="52" cy="37" r="1" fill="white" />
      <circle cx="72" cy="37" r="1" fill="white" />
      {/* Nostrils */}
      <circle cx="56" cy="48" r="1.5" fill={bodyColor} />
      <circle cx="64" cy="48" r="1.5" fill={bodyColor} />
      {/* Smoke puffs */}
      <circle cx="54" cy="44" r="1" fill="#CCC" opacity="0.4" />
      <circle cx="66" cy="45" r="0.8" fill="#CCC" opacity="0.3" />
      {/* Smile */}
      <path d="M54 52C54 52 57 55 60 55C63 55 66 52 66 52" stroke={bodyColor} strokeWidth="1" strokeLinecap="round" fill="none" />
    </svg>
  );
}
